import { render, staticRenderFns } from "./QuoteBuilderSubletComponent.vue?vue&type=template&id=2afc8b18&scoped=true"
import script from "./QuoteBuilderSubletComponent.vue?vue&type=script&lang=js"
export * from "./QuoteBuilderSubletComponent.vue?vue&type=script&lang=js"
import style0 from "./QuoteBuilderSubletComponent.vue?vue&type=style&index=0&id=2afc8b18&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afc8b18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2afc8b18')) {
      api.createRecord('2afc8b18', component.options)
    } else {
      api.reload('2afc8b18', component.options)
    }
    module.hot.accept("./QuoteBuilderSubletComponent.vue?vue&type=template&id=2afc8b18&scoped=true", function () {
      api.rerender('2afc8b18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/quoteBuilder/ItemTypeComponents/quoteBuilderSublets/QuoteBuilderSubletComponent.vue"
export default component.exports